import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  message: null,
  type: "info",
  title: "",
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotification: (state, action) => {
      state.message = action.payload.message;
      state.type = action.payload.type;
      state.title = action.payload.title;
    },
    clearNotification: (state) => {
      state.message = null;
      state.type = "info";
      state.title = "";
    },
  },
});

export const { setNotification, clearNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
